// This file was automatically generated from appchart.mainFeeds.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.mainFeeds');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.render.reportFeedItem.resultGrid');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.mainFeeds.chart = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div id="chart-section-header"><h3 class="el8QueueHeader el8InlineBlock"><span class="el8Wrap">Chronological Record</span></h3><div class="el8ButtonContainer fr"><div class="mr15 el8StandardFontSize el8InlineBlock"><span class="el8AppText">Ordering By: </span><a id="chart-feed-sort-menu-trigger" class="el8FeedActionsLink"></a></div><div class="el8InlineBlock el8StandardFontSize"><a class="refresh-chart-feed-trigger">Refresh</a></div></div></div><div id="lab-results-table-holder"></div><ol id="', soy.$$escapeHtml(opt_data.listId), '" class="el8Feed"></ol><div class="moreFeedContainer">', (opt_data.infiniteScroll) ? '<div class="el8Loading"></div><div id="chart-feed-more-trigger" class="invisible"></div>' : '<button id="chart-feed-more-trigger" class="el8button moreFeed"></button>', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.mainFeeds.chartMagicTable = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="lab-results-table padv15 el8FieldSectionOverflow">');
  var typeList3865 = opt_data.results.group_types;
  var typeListLen3865 = typeList3865.length;
  for (var typeIndex3865 = 0; typeIndex3865 < typeListLen3865; typeIndex3865++) {
    var typeData3865 = typeList3865[typeIndex3865];
    output.append((typeData3865 == 'labs') ? '<div class="padh10 el8AlignRight el8AppColor el8FixedText">Note: Click on the lab value to see entire lab report.</div>' : (typeData3865 == 'vaccines') ? '<ul class="padh10 el8ButtonContainer"><li class="el8LgSpaceButtonItem"><button class="el8button el8IconButton print-immunizations-trigger"><span class="el8PrintIcon"></span>Immunization Hx</button></li><li class="el8LgSpaceButtonItem mt10"><a class="el8IconButton el8button el8333 schedule-immunizations-trigger" data-amplitude-schedule="ped_cdcschedule" target="_blank" rel="noopener" href="https://www.cdc.gov/vaccines/schedules/downloads/child/0-18yrs-child-combined-schedule.pdf"><span class="el8ViewIcon"></span>CDC Schedule: 0-18</a></li><li class="mt10 el8LgSpaceButtonItem"><a class="el8IconButton el8button el8333 schedule-immunizations-trigger" data-amplitude-schedule="adult_cdcschedule" target="_blank" rel="noopener" href="https://www.cdc.gov/vaccines/schedules/downloads/adult/adult-combined-schedule.pdf"><span class="el8ViewIcon"></span>CDC Schedule: Adult</a></li>' + ((opt_data.showForecast) ? '<li class="el8LgSpaceButtonItem mt10"><button class="el8button check-forecast-immunizations-trigger" data-testid="immunization-table-check-forecast-button">Check Forecast</button></li>' : '') + '</ul>' : (typeData3865 == 'vitals') ? '<div class="padh10 el8AlignRight el8AppColor el8FixedText">* Italicized vitals are from unsigned visit notes.</div>' : '');
  }
  var groupList3878 = opt_data.results.groups;
  var groupListLen3878 = groupList3878.length;
  for (var groupIndex3878 = 0; groupIndex3878 < groupListLen3878; groupIndex3878++) {
    var groupData3878 = groupList3878[groupIndex3878];
    if (groupData3878.type == 'vaccines') {
      el8.template.appchart.mainFeeds.chartMagicTableVaccineGroup(soy.$$augmentData(opt_data, {group: groupData3878}), output);
    } else {
      el8.template.appchart.mainFeeds.chartMagicTableGroup({group: groupData3878}, output);
    }
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.mainFeeds.chartMagicTableGroup = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8MagicTableContainer mv5"><div class="el8MagicTableLeftHeaderHelper"><table class="el8MagicTable"><tbody><tr><th style="height:33px;"></th>');
  var dtList3890 = opt_data.group.dates;
  var dtListLen3890 = dtList3890.length;
  for (var dtIndex3890 = 0; dtIndex3890 < dtListLen3890; dtIndex3890++) {
    var dtData3890 = dtList3890[dtIndex3890];
    output.append('<td class="el8DateHeader">', soy.$$escapeHtml(dtData3890), '</td>');
  }
  output.append('</tr>');
  var rowList3896 = opt_data.group.rows;
  var rowListLen3896 = rowList3896.length;
  for (var rowIndex3896 = 0; rowIndex3896 < rowListLen3896; rowIndex3896++) {
    var rowData3896 = rowList3896[rowIndex3896];
    output.append('<tr class="magic-table-row"><th>', soy.$$escapeHtml(rowData3896.name), '</th>');
    var valueList3900 = rowData3896.values;
    var valueListLen3900 = valueList3900.length;
    for (var valueIndex3900 = 0; valueIndex3900 < valueListLen3900; valueIndex3900++) {
      var valueData3900 = valueList3900[valueIndex3900];
      output.append('<td class="', (valueData3900.is_abnormal) ? 'el8AbnormalValue' : '', (valueData3900.signed == false) ? ' el8AppText el8ItalicText' : '', '">');
      if (valueData3900.documenting_personnel_id) {
        output.append('<div class="labPreviousValueInput">');
        if (valueData3900.is_from_care_team) {
          el8.template.render.reportFeedItem.resultGrid.smallManualPlrDocIcon(null, output);
          output.append('<a class="plr-item-details-trigger" data-id="', soy.$$escapeHtml(valueData3900.id), '">', soy.$$escapeHtml(valueData3900.value), '</a>');
        } else {
          el8.template.render.reportFeedItem.resultGrid.smallManualDocIcon({documentingPersonnelType: valueData3900.documenting_personnel_type, documentingPersonnelId: valueData3900.documenting_personnel_id}, output);
          output.append('<a class="item-details-trigger" data-id="', soy.$$escapeHtml(valueData3900.id), '">', soy.$$escapeHtml(valueData3900.value), '</a>');
        }
        output.append('</div>');
      } else {
        if (valueData3900.is_from_care_team) {
          output.append('<div class="labPreviousValueInput">');
          if (valueData3900.id) {
            el8.template.render.reportFeedItem.resultGrid.smallManualPlrDocIcon(null, output);
            output.append('<a class="plr-item-details-trigger" data-id="', soy.$$escapeHtml(valueData3900.id), '">', soy.$$escapeHtml(valueData3900.value), '</a>');
          } else {
            output.append(soy.$$escapeHtml(valueData3900.value));
          }
          output.append('</div>');
        } else {
          output.append((valueData3900.id) ? '<a class="item-details-trigger" data-id="' + soy.$$escapeHtml(valueData3900.id) + '">' + soy.$$escapeHtml(valueData3900.value) + '</a>' : soy.$$escapeHtml(valueData3900.value));
        }
      }
      output.append('</td>');
    }
    output.append('</tr>');
  }
  output.append('</tbody></table></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.mainFeeds.chartMagicTableVaccineGroup = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="vaccine-magic-table el8ValuesContainer"><ol class="left-scroll-shadow el8ValuesHeaderWrap">', (opt_data.query == 'vaccine' || opt_data.query == 'vaccines' || opt_data.query == 'adult vaccines' || opt_data.query == 'pediatric vaccines') ? '<li class="el8ValuesHeaderTop"><select id="magictable-vaccine-set-dropdown" class="vaccine-set-dropdown"><option value="pediatric vaccines"' + ((opt_data.query == 'pediatric vaccines' || opt_data.query.startswith('vaccine') && opt_data.patientAge <= 18) ? ' selected="selected"' : '') + '>Pediatric Set</option><option value="adult vaccines"' + ((opt_data.query == 'adult vaccines' || opt_data.query.startswith('vaccine') && opt_data.patientAge > 18) ? ' selected="selected"' : '') + '>Adult Set</option></select></li>' : '<li class="el8ValuesHeaderTop">Vaccine Name</li>');
  var rowList3975 = opt_data.group.rows;
  var rowListLen3975 = rowList3975.length;
  for (var rowIndex3975 = 0; rowIndex3975 < rowListLen3975; rowIndex3975++) {
    var rowData3975 = rowList3975[rowIndex3975];
    output.append('<li class="el8ValuesHeaderItem"><span class="el8StandardFontSize">', soy.$$escapeHtml(rowData3975.name), '</span></li>');
  }
  output.append('</ol><div class="el8OverflowAuto el8ValuesContainerRightBorder vaccine-scrollable"><div class="el8ValuesWrap values-wrap"><ol class="el8ValuesTopRowWrap"><li class="el8ValuesRowHeaderTop">1st Dose</li><li class="el8ValuesRowHeaderTop">2nd Dose</li><li class="el8ValuesRowHeaderTop">3rd Dose</li><li class="el8ValuesRowHeaderTop">4th Dose</li><li class="el8ValuesRowHeaderTop">5th Dose</li><li class="el8ValuesRowHeaderTop">6th Dose</li></ol>');
  var rowList3981 = opt_data.group.rows;
  var rowListLen3981 = rowList3981.length;
  for (var rowIndex3981 = 0; rowIndex3981 < rowListLen3981; rowIndex3981++) {
    var rowData3981 = rowList3981[rowIndex3981];
    output.append('<ol class="el8ValuesRowWrap values-row-wrap">');
    var valueList3983 = rowData3981.values;
    var valueListLen3983 = valueList3983.length;
    for (var valueIndex3983 = 0; valueIndex3983 < valueListLen3983; valueIndex3983++) {
      var valueData3983 = valueList3983[valueIndex3983];
      if (valueData3983.model_class == 'PatientImmunization') {
        el8.template.appchart.mainFeeds.ptImmCell(valueData3983, output);
      } else if (valueData3983.model_class == 'PatientImmunizationDecline') {
        output.append('<li class="el8ValuesRowItem"><a class="delete-trigger el8RemoveButton" data-id="', soy.$$escapeHtml(valueData3983.id), '"></a><p class="el8VaccineDecline">', soy.$$escapeHtml(valueData3983.value), '<br />', (soy.$$escapeHtml(valueData3983.date)? el8.service.tz.soyDate(soy.$$escapeHtml(valueData3983.date)) : ''), '</p></li>');
      } else if (valueData3983.value == 'el8TriggerPlaceholder') {
        output.append('<li class="el8ValuesRowItem el8CellHover imm-quick-form" data-index="', soy.$$escapeHtml(rowIndex3981), '"><div class="el8VaccineTextareaWrap"><input type="text" class="w100" name="administeredDate" data-name="', soy.$$escapeHtml(rowData3981.name), '" /></div><p class="mt7"><a class="el8NormalText el8StandardFontSize el8FormLink add-immunization-trigger" data-name="', soy.$$escapeHtml(rowData3981.name), '" tabindex="-1">Actions</a></p></li>');
      }
    }
    output.append('</ol>');
  }
  output.append('</div></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.mainFeeds.ptImmCell = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="el8ValuesRowItem el8CellHover item-details-trigger" data-id="', soy.$$escapeHtml(opt_data.id), '"><a class="delete-trigger el8RemoveButton" data-id="', soy.$$escapeHtml(opt_data.id), '"></a><p class="el8VaccineText">', (soy.$$escapeHtml(opt_data.date)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.date)) : ''), (opt_data.value) ? '<br /><span class="el8NormalText el8StandardFontSize">' + soy.$$escapeHtml(opt_data.value) + '</span>' : '', '</p></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.mainFeeds.tempPtImmCell = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="el8ValuesRowItem el8Loading" style="height: 65px"></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.mainFeeds.reqAct = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<h3 id="reqact-collapse-trigger" class="el8QueueHeader el8AttentionText el8CursorPointer el8InlineBlock"><span id="reqact-collapse-status"></span><span class="el8Wrap">Requiring Action<div id="', soy.$$escapeHtml(opt_data.counterId), '" class="reqActHeaderCount"></div></span></h3><a class="refresh-req-action-trigger el8StandardFontSize el8InlineBlock fr">Refresh</a><ol id="', soy.$$escapeHtml(opt_data.listId), '" class="el8Feed"></ol>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.mainFeeds.outstanding = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<h3 id="outstanding-collapse-trigger" class="el8QueueHeader el8CursorPointer el8InlineBlock"><span id="outstanding-collapse-status"></span><span class="el8Wrap">Outstanding Items<div id="', soy.$$escapeHtml(opt_data.counterId), '" class="outstandingHeaderCount"></div></span></h3><a class="refresh-req-action-trigger el8StandardFontSize el8InlineBlock ml15">Refresh</a><ol id="', soy.$$escapeHtml(opt_data.listId), '" class="el8Feed"></ol>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.mainFeeds.searchResultsLabel = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="filterResultsNotifier">Search Results</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.mainFeeds.graphTooltip = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div id="chart-feed-graph-tooltip" class="chartFeedGraphTooltip">', soy.$$escapeHtml(opt_data.contents), '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.mainFeeds.emptyChart = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8AlignCenter"><h5 class="el8FeedEmpty">This chart is empty</h5><img src="/static/images/empty_chart.png" class="el8AlignCenter mt10" /></div><h5 class="mt20 el8FeedEmpty">Start adding to the chart:</h5><div class="clearfix w100"><div class="el8Col4"><div class="mh20 el8CalloutBox"><img src="/static/images/empty_chart_arrow.png" class="el8EmptyChartArrow" /><h4 class="el8CalloutHeader padb10">Fill out the Clinical Profile</h4><p>Fill out fields along the left side of the screen, such as the patient\'s allergies or past medical history.</p></div></div><div class="el8Col4"><div class="mh20 el8CalloutBox"><h4 class="el8CalloutHeader">Drag and drop the patient\'s CCDs or CDAs into the chart</h4></div></div><div class="el8Col4"><div class="mh20 el8CalloutBox"><h4 class="el8CalloutHeader">Write a Visit Note</h4><p class="padb15">Use the button below or click the Visit Note button in the menu bar above.</p><p class="el8AlignCenter"><button class="el8button el8PrimaryButton ebs-btn ebs-btn-primary w100 visit_note_trigger">Create Note</button></p></div></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.mainFeeds.plrPassiveNotification = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="plr-passive-notification-trigger el8PassiveNotification"><span class="el8FeedItemNewPlrMarker mr5"></span>', (el8Globals.FEATURES.PLR4Everyone) ? ' New from All Sharing Providers: ' : ' New from PLR: ');
  var pairList4051 = opt_data.pairs;
  var pairListLen4051 = pairList4051.length;
  for (var pairIndex4051 = 0; pairIndex4051 < pairListLen4051; pairIndex4051++) {
    var pairData4051 = pairList4051[pairIndex4051];
    output.append(soy.$$escapeHtml(pairData4051[1]), ' ');
    el8.template.appchart.mainFeeds._plrNotificationModelName({modelClass: pairData4051[0]}, output);
    output.append((pairData4051[1] > 1) ? 's' : '', (opt_data.pairs.length > 1 && ! (pairIndex4051 == pairListLen4051 - 1)) ? ', ' : '');
  }
  output.append((opt_data.compareProfile) ? ((opt_data.pairs.length) ? ', and ' : '') + ' profile updates' : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.mainFeeds._plrNotificationModelName = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  switch (opt_data.modelClass) {
    case 'VisitNote':
      output.append('visit note');
      break;
    case 'NonvisitNote':
      output.append('non-visit note');
      break;
    case 'Report':
      output.append('report');
      break;
    case 'ImagingOrder':
      output.append('imaging order');
      break;
    case 'CardiacOrder':
      output.append('cardiac order');
      break;
    case 'SleepOrder':
      output.append('<!-- Sleep to Generic order UI reskin -->', (el8Globals.FEATURES.GenericOrder) ? 'order' : 'sleep order');
      break;
    case 'PulmonaryOrder':
      output.append('pulmonary order');
      break;
    case 'LabOrder':
      output.append('lab order');
      break;
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.mainFeeds.typeFacet = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(soy.$$escapeHtml(el8.util.consts.DOCTYPE_FACET_VALUE), ' <span class="el8SearchFacetExample"> Visit Notes, Reports&hellip;</span>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.mainFeeds.sharedByFacet = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(soy.$$escapeHtml(el8.util.consts.SHARED_BY_FACET_VALUE), ' <span class="el8SearchFacetExample">e.g. John Smith, MD</span>');
  if (!opt_sb) return output.toString();
};
